import React, { useState } from "react"
import { Box } from "@mui/material"
import RecipeCard from "./RecipeCard"

const SortableRecipeCard = ({ recipeId, placement, onDragStart, onDragEnd, onRemove, onChooseProdDay }) => {
  const [isDragging, setIsDragging] = useState(false)

  const handleDragStart = (e) => {
    if (e.target.closest && e.target.closest("[data-no-drag]")) {
      e.preventDefault()
      return
    }
    e.dataTransfer.effectAllowed = "move"
    e.dataTransfer.setData("text/plain", recipeId)
    setIsDragging(true)
    onDragStart()
  }

  const handleDragEnd = () => {
    setIsDragging(false)
    onDragEnd()
  }

  const { recipe } = placement
  const isPendingChoice = placement.prodDate === null && (recipe.prodDates || []).length > 1
  const pendingDates = isPendingChoice ? recipe.prodDates : []
  const displayProdDates = placement.prodDate ? [placement.prodDate] : recipe.prodDates

  return (
    <Box
      draggable
      data-recipe-id={recipeId}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      sx={{ opacity: isDragging ? 0.4 : 1, cursor: isDragging ? "grabbing" : "grab", outline: "none" }}
    >
      <RecipeCard
        recipe={recipe}
        displayProdDates={displayProdDates}
        pendingDates={pendingDates}
        onChoosePendingDate={onChooseProdDay}
        onRemove={onRemove}
      />
    </Box>
  )
}

export default SortableRecipeCard
